<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyQuestionTabLinks />
                    <SurveyQuestionCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/surveys`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyQuestionTabLinks from '@/components/surveys/SurveyQuestionTabLinks';
    import SurveyQuestionCard from '@/components/surveys/SurveyQuestionCard';

    export default {
        name: 'Survey',

        components: {
            SurveyQuestionTabLinks,
            SurveyQuestionCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id, question_id } = this.$route.params;
                this.entity = (await this.axios.get(`/surveys/${id}/questions/${question_id}`)).data;
            },
        },
    };
</script>
